import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import { Nullable, UserWithToken, WithData } from './api.types';

export const registerPushToken = async (
  user: Nullable<UserWithToken>,
  variables: { token: string; deviceUuid: string }
) =>
  getGraphQLQueryClient(user).request<WithData<boolean>>(
    gql`
      mutation registerPushToken($token: String!, $deviceUuid: String!) {
        data: registerPushToken(token: $token, deviceUuid: $deviceUuid)
      }
    `,
    variables
  );

export const unregisterPushToken = async (
  user: Nullable<UserWithToken>,
  variables: { deviceUuid: string }
) =>
  getGraphQLQueryClient(user).request<WithData<boolean>>(
    gql`
      mutation unregisterPushToken($deviceUuid: String!) {
        data: unregisterPushToken(deviceUuid: $deviceUuid)
      }
    `,
    variables
  );
